import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

//Layout
import AuthLayout from "./layouts/Auth";
import EmptyLayout from "./layouts/Empty";
import AdminLayout from "./layouts/Admin";

//Context
import { useAuth } from './context/auth';

//Components
import Loading from './components/Loading/Loading';

export default function RoutesComponent() {
    const { session, loading, setupVariavel } = useAuth();
    return (
        <BrowserRouter>
            {loading && <Loading />}
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path="/" element={<Navigate to={`auth/login`} />} />
                    <Route path={`auth/*`} element={<AuthLayout />} />
                    <Route path={`empty/*`} element={<EmptyLayout />} />
                    {session != null &&
                        setupVariavel?.siglaDocumentoColeta != null &&
                        <Route path={`admin/*`} element={<AdminLayout />} />
                    }
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}
